import { S3_BASE } from '../../../constants';
import './index.scss';
import { MdEmail } from 'react-icons/md';
import { FaFacebook, FaYoutube } from 'react-icons/fa';

const logo = `${S3_BASE}/luocsu/logo.png`;

function Footer() {
  return (
    <div className={'Footer NavBar'}>
      <div className={'logo'}>
        <img src={logo} />
        <div className={'site-name'}>
          <h3>Pháp Tạng Phật Giáo Việt Nam</h3>
          <h2>Nhất Tôn Như Lai Tạng</h2>
        </div>
      </div>

      <div className={'contact'}>
        <div className='text'> Liên hệ và theo dõi chúng tôi:</div>
        <div className={'icons'}>
          <a className={'email'} href={'mailto:nhattonnhulaitang@gmail.com'}><MdEmail /></a>
          <a className={'facebook'} href={'https://s.net.vn/IMUI'}><FaFacebook /></a>
          <a className={'youtube'} href={'https://s.net.vn/J70T'}><FaYoutube /></a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
